import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//shows details about moving trucks,moving people,hourly rate moving hours,resource price.
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    const movingCount = IV1_PageDetails.StartEndTime.filter(
        item => item.HoursType === "Moving"
    ).length;
    return (
        IV1_PageDetails.DigitalInvoicePagePricingData ?
            <div className="moving_charges_2">
                <div className="row">
                    <div className="col d-flex">
                        <input type="text" className="form-control input_field_3"
                               placeholder={IV1_PageDetails.DigitalInvoicePagePricingData.MovingTrucks} disabled />
                        &nbsp;&nbsp;
                        <p className="charges_text">MOVING VAN(S) AND</p>
                    </div>
                    <div className="col d-flex">
                        <input type="text" className="form-control input_field_3"
                               placeholder={IV1_PageDetails.DigitalInvoicePagePricingData.MovingPeople} disabled />
                        &nbsp;&nbsp;
                        <p className="charges_text">{IV1_PageDetails.DigitalInvoicePagePricingData.CrewMemberVerbiage}</p>
                    </div>
                    {
                        IV1_PageDetails.DigitalInvoicePagePricingData.HourType &&
                        movingCount <= 1 ? (
                            <>
                                <div className="col d-flex">
                                    <p className="charges_text">@ </p>&nbsp;&nbsp;
                                    <p className="charge_text">{IV1_PageDetails.Currency}</p>&nbsp;&nbsp;

                                    <input
                                        type="text"
                                        className="form-control input_field_3"
                                        placeholder={IV1_PageDetails.DigitalInvoicePagePricingData.HourlyRate}
                                        disabled
                                    />

                                    &nbsp;&nbsp;
                                    <p className="charges_text">PER HOUR, FOR</p>&nbsp;&nbsp;
                                </div>
                            </>
                        ) : (
                            ""
                        )
                    }
                    <div className="col d-flex">
                        <input type="text" className="form-control input_field_3"
                             placeholder={IV1_PageDetails.DigitalInvoicePagePricingData.MovingHour} disabled />
                        &nbsp;&nbsp;
                        <p className="charges_text">HOURS</p>
                    </div>
                    <div className="col d-flex">
                        <input type="text" className="form-control input_field_4"
                               placeholder={IV1_PageDetails.DigitalInvoicePagePricingData.ResourcePrice} disabled />
                    </div>
                </div>

            </div>
                : <></>

    )
}